export default __webpack_public_path__ + "static/media/7Y.6eafca54.png";